/*!
 * DrawSVGPlugin 3.8.0
 * https://greensock.com
 *
 * @license Copyright 2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
 */
window._gsapWarned = 1;

!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? t(exports)
    : "function" == typeof define && window.define.amd
    ? window.define(["exports"], t)
    : t(((e = e || self).window = e.window || {}));
})(this, function (e) {
  "use strict";
  function i() {
    return "undefined" != typeof window;
  }
  function j() {
    return a || (i() && (a = window.gsap) && a.registerPlugin && a);
  }
  function m(e) {
    return Math.round(1e4 * e) / 1e4;
  }
  function n(e) {
    return parseFloat(e) || 0;
  }
  function o(e, t) {
    var i = n(e);
    return ~e.indexOf("%") ? (i / 100) * t : i;
  }
  function p(e, t) {
    return n(e.getAttribute(t));
  }
  function r(e, t, i, r, o, s) {
    return P(Math.pow((n(i) - n(e)) * o, 2) + Math.pow((n(r) - n(t)) * s, 2));
  }
  function s(e) {
    return console.warn(e);
  }
  function t(e) {
    return "non-scaling-stroke" === e.getAttribute("vector-effect");
  }
  // function w() {
  //  return String.fromCharCode.apply(null, arguments);
  // }
  function A(e) {
    if (!(e = v(e)[0])) return 0;
    var n,
      i,
      o,
      a,
      f,
      w,
      d,
      l = e.tagName.toLowerCase(),
      h = e.style,
      u = 1,
      c = 1;
    t(e) &&
      ((c = e.getScreenCTM()),
      (u = P(c.a * c.a + c.b * c.b)),
      (c = P(c.d * c.d + c.c * c.c)));
    try {
      i = e.getBBox();
    } catch (e) {
      s(
        "Some browsers won't measure invisible elements (like display:none or masks inside defs)."
      );
    }
    var g = i || { x: 0, y: 0, width: 0, height: 0 },
      _ = g.x,
      y = g.y,
      x = g.width,
      m = g.height;
    if (
      ((i && (x || m)) ||
        !k[l] ||
        ((x = p(e, k[l][0])),
        (m = p(e, k[l][1])),
        "rect" !== l && "line" !== l && ((x *= 2), (m *= 2)),
        "line" === l &&
          ((_ = p(e, "x1")),
          (y = p(e, "y1")),
          (x = Math.abs(x - _)),
          (m = Math.abs(m - y)))),
      "path" === l)
    )
      (a = h.strokeDasharray),
        (h.strokeDasharray = "none"),
        (n = e.getTotalLength() || 0),
        u !== c &&
          s(
            "Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled."
          ),
        (n *= (u + c) / 2),
        (h.strokeDasharray = a);
    else if ("rect" === l) n = 2 * x * u + 2 * m * c;
    else if ("line" === l) n = r(_, y, _ + x, y + m, u, c);
    else if ("polyline" === l || "polygon" === l)
      for (
        o = e.getAttribute("points").match(b) || [],
          "polygon" === l && o.push(o[0], o[1]),
          n = 0,
          f = 2;
        f < o.length;
        f += 2
      )
        n += r(o[f - 2], o[f - 1], o[f], o[f + 1], u, c) || 0;
    else
      ("circle" !== l && "ellipse" !== l) ||
        ((w = (x / 2) * u),
        (d = (m / 2) * c),
        (n = Math.PI * (3 * (w + d) - P((3 * w + d) * (w + 3 * d)))));
    return n || 0;
  }
  function B(e, t) {
    if (!(e = v(e)[0])) return [0, 0];
    t = t || A(e) + 1;
    var i = d.getComputedStyle(e),
      r = i.strokeDasharray || "",
      o = n(i.strokeDashoffset),
      s = r.indexOf(",");
    return (
      s < 0 && (s = r.indexOf(" ")),
      t < (r = s < 0 ? t : n(r.substr(0, s))) && (r = t),
      [-o || 0, r - o || 0]
    );
  }
  function C() {
    i() &&
      ((d = window),
      (h = a = j()),
      (v = a.utils.toArray),
      (l = -1 !== ((d.navigator || {}).userAgent || "").indexOf("Edge")));
  }
  var a,
    v,
    d,
    l,
    h,
    // eslint-disable-next-line no-useless-escape
    b = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi,
    k = {
      rect: ["width", "height"],
      circle: ["r", "r"],
      ellipse: ["rx", "ry"],
      line: ["x2", "y2"],
    },
    P = Math.sqrt,
    f = "DrawSVGPlugin",
    u = "greensock.com",
    c = (function (e) {
      var t =
          0 === (window ? window.location.href : "").indexOf("file://") ||
          -1 !== e.indexOf("localhost") ||
          -1 !== e.indexOf("127.0 0.1"),
        n = [
          u,
          "codepen.io",
          "codepen.plumbing",
          "codepen.dev",
          "codepen.app",
          "pens.cloud",
          "css-tricks.com",
          "cdpn.io",
          "pens.io",
          "gannon.tv",
          "codecanyon.net",
          "themeforest.net",
          "cerebrax.co.uk",
          "tympanus.net",
          "tweenmax.com",
          "tweenlite.com",
          "plnkr.co",
          "hotjar.com",
          "webpackbin.com",
          "archive.org",
          "codesandbox.io",
          "csb.app",
          "stackblitz.com",
          "codier.io",
          "motiontricks.com",
          "stackoverflow.com",
          "stackexchange.com",
          "jsfiddle.net",
          "www.oisrf.ru",
        ],
        i = n.length;
      for (
        // TODO: remove this warning
        setTimeout(function () {
          window &&
            window.console &&
            !window._gsapWarned &&
            a &&
            !1 !== a.config().trialWarn &&
            (console.log("%cWarning", "font-size:30px;color:red;"),
            console.log(
              "A trial version of " +
                f +
                " is loaded that only works locally and on domains like codepen.io and codesandbox.io. *** DO NOT DEPLOY THIS FILE *** Loading it on an unauthorized site violates the license and will cause a redirect. Please join Club GreenSock to get full access to the bonus plugins that boost your animation superpowers. Disable this warning with gsap.config({trialWarn: false});"
            ),
            console.log(
              "%cGet unrestricted files at https://greensock.com/club",
              "font-size:16px;color:#4e9815"
            ),
            (window._gsapWarned = 1));
        }, 50);
        -1 < --i;

      )
        if (-1 !== e.indexOf(n[i])) return !0;
      return (
        t ||
        !setTimeout(function () {
          window.location.href =
            "https://" +
            u +
            "/requires-membership/" +
            "?plugin=" +
            f +
            "&source=codepen";
        }, 3e3)
      );
    })(window ? window.location.host : ""),
    g = {
      version: "3.8.0",
      name: "drawSVG",
      register: function register(e) {
        (a = e), C();
      },
      init: function init(e, i) {
        if (!e.getBBox) return !1;
        h || C();
        var r,
          s,
          a,
          f = A(e);
        return (
          (this._style = e.style),
          (this._target = e),
          i + "" == "true"
            ? (i = "0 100%")
            : i
            ? -1 === (i + "").indexOf(" ") && (i = "0 " + i)
            : (i = "0 0"),
          (s = (function _parse(e, t, n) {
            var i,
              r,
              s = e.indexOf(" ");
            return (
              (r =
                s < 0
                  ? ((i = void 0 !== n ? n + "" : e), e)
                  : ((i = e.substr(0, s)), e.substr(s + 1))),
              (i = o(i, t)),
              (r = o(r, t)) < i ? [r, i] : [i, r]
            );
          })(i, f, (r = B(e, f))[0])),
          (this._length = m(f)),
          (this._dash = m(r[1] - r[0])),
          (this._offset = m(-r[0])),
          (this._dashPT = this.add(this, "_dash", this._dash, m(s[1] - s[0]))),
          (this._offsetPT = this.add(this, "_offset", this._offset, m(-s[0]))),
          l &&
            (a = d.getComputedStyle(e)).strokeLinecap !== a.strokeLinejoin &&
            ((s = n(a.strokeMiterlimit)),
            this.add(e.style, "strokeMiterlimit", s, s + 0.01)),
          (this._live = t(e) || ~(i + "").indexOf("live")),
          (this._nowrap = ~(i + "").indexOf("nowrap")),
          this._props.push("drawSVG"),
          c
        );
      },
      render: function render(e, t) {
        var n,
          i,
          r,
          o,
          s = t._pt,
          a = t._style;
        if (s) {
          for (
            t._live &&
            (n = A(t._target)) !== t._length &&
            ((i = n / t._length),
            (t._length = n),
            t._offsetPT && ((t._offsetPT.s *= i), (t._offsetPT.c *= i)),
            t._dashPT
              ? ((t._dashPT.s *= i), (t._dashPT.c *= i))
              : (t._dash *= i));
            s;

          )
            s.r(e, s.d), (s = s._next);
          (r = t._dash || (e && 1 !== e && 1e-4) || 0),
            (n = t._length - r + 0.1),
            (o = t._offset),
            r &&
              o &&
              r + Math.abs(o % t._length) > t._length - 0.2 &&
              (o += o < 0 ? 0.1 : -0.1) &&
              (n += 0.1),
            (a.strokeDashoffset = r ? o : o + 0.001),
            (a.strokeDasharray =
              n < 0.2
                ? "none"
                : r
                ? r + "px," + (t._nowrap ? 999999 : n) + "px"
                : "0px, 999999px");
        }
      },
      getLength: A,
      getPosition: B,
    };
  j() && a.registerPlugin(g), (e.DrawSVGPlugin = g), (e.default = g);
  if (typeof window === "undefined" || window !== e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
  } else {
    delete e.default;
  }
});
